import React from 'react';
import _ from 'lodash';

import { DateInput } from '../../DateInput';
import { Tel } from '../Tel';
import { PostalCode } from '../PostalCode';
import { WorkerInputText } from '../WorkerInputText.jsx';
import { WorkerRadioText } from '../WorkerRadioText.jsx';

import AttachDocument from '../../forms/AttachDocument';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { CcusLineComponent, CcusTitleBlock } from '../../CcusFormComponent';
import ComboBox from '../../combobox/ComboBox';
import { Description } from '../../Description';
import { FormSelect } from '../../FormSelect';

import { WORKER_RESIDENCE_STATUS_CODES } from '../../../utilities/constants';
import {
  getTextBloodTypeId,
  getTextBloodTypeRhId,
  getTextNationalityInfoId,
  getTextExistanceFlag,
} from '../../../utilities/constantsUtil';
import {
  isSafariBrowser,
  isArrayAll,
  isFunctionAll,
  isNotUndefinedAll,
} from '../../../utilities/commonUtil';
import { messageUtility } from '../../../utilities/messageUtility';
import { wrapperValidExpirationDate } from '../../../utilities/dateSelectorUtility';

import {
  NATIONALITY_INFO,
  BLOOD_TYPE_RH,
  BLOOD_TYPE,
  EXISTANCE_FLAG,
  PREFECTURE_GROUPS,
  RESIDENT_DESCRIPTION_MESSAGE,
} from '../../../utilities/constants';

import styles from '../../../styles/componentStyle/worker/workerInfo/ccus-worker-info-form.scss';
import residenceCardImage from '../../../images/img-residence-card.jpg';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';

/**
 * 労務安全基本情報
 * 画面遷移
 *  - 自社作業員一覧>>労務安全基本情報
 */
const WorkerSafetyBasicInfoForm = ({
  events,
  formValues,
  messages,
  disabledAll,
  isOverSixteen,
  comboBoxList,
  attachDocumentCodes_Certificate,
  attachDocuments_Certificate,
  ccusDescription,
  isCcusJigyousyaDeleted,
}) => {
  if (
    !isNotUndefinedAll(events, formValues, messages, disabledAll, comboBoxList)
  ) {
    throw new Error('WorkerSafetyBasicInfoForm.jsx function call');
  }
  if (
    !isArrayAll(attachDocumentCodes_Certificate, attachDocuments_Certificate)
  ) {
    throw new Error('WorkerSafetyBasicInfoForm.jsx function call');
  }

  if (
    !isFunctionAll(
      events.setValueWorkerSafetyBasicInfo,
      events.setWorkerSafetyBasicInfoResidentStatus,
      events.setCCUSValuesDetail,
      events.validate,
      events.uploadFile,
      events.download,
      events.deleteFile
    )
  ) {
    throw new Error('WorkerSafetyBasicInfoForm.jsx function call');
  }

  // 外国籍時の『在留期間満了日』の補足メッセージを修正する
  let residentDescriptionMessage = messageUtility.getMessage('I-000-142');
  if (isOverSixteen === false) {
    residentDescriptionMessage = messageUtility.getMessage('I-000-145');
  } else {
    _.forEach(RESIDENT_DESCRIPTION_MESSAGE, it => {
      if (
        it.RESIDENT_CODE === formValues.workerSafetyBasicInfo.resident_status
      ) {
        residentDescriptionMessage = it.MESSAGE;
      }
    });
  }

  let hasValueCCUSbtn = false;

  const FormRadio = ({ label, name, events, value, checked, disabled }) => (
    <div className='form-list-radio__item'>
      <label className='radio'>
        <input
          name={name}
          type='radio'
          checked={checked}
          value={value}
          onChange={e => {
            events.setValueWorkerSafetyBasicInfo(e.target.name, e.target.value);
          }}
          disabled={disabled}
        />
        <RadioButtonIcon className='icon--2x' />
        <span>{label}</span>
      </label>
    </div>
  );

  const showRadioValueForeignerFlag = value => {
    const result = getTextNationalityInfoId(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueBloodType = value => {
    const result = getTextBloodTypeId(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueBloodTypeRh = value => {
    const result = getTextBloodTypeRhId(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const showRadioValueExistance = value => {
    const result = getTextExistanceFlag(value);
    if (_.isUndefined(result)) {
      return '';
    }
    return result;
  };

  const employmentEducationDateIsDisable = () => {
    return (
      formValues.workerSafetyBasicInfo.education !== EXISTANCE_FLAG.EXIST.ID
    );
  };

  const ccusElement = key => {
    let val = '';
    // BLDE_V2-50226 CCUS事業者IDは削除された場合に、転記情報は表示されない
    if (!isCcusJigyousyaDeleted) {
      if (key === 'foreigner_flag') {
        val = showRadioValueForeignerFlag(formValues.ccus_info.foreigner_flag);
      } else if (key === 'blood_type') {
        val = showRadioValueBloodType(formValues.ccus_info.blood_type);
      } else if (key === 'resident_status') {
        val = formValues.ccus_info.resident_status_name;
      } else {
        val = formValues.ccus_info ? formValues.ccus_info[key] : null;
      }
      if (!val || disabledAll) {
        return null;
      }
      hasValueCCUSbtn = true;
      return (
        <CcusLineComponent onClick={() => events.setCCUSValuesDetail(key)}>
          {val}
        </CcusLineComponent>
      );
    } else {
      return null;
    }
  };
  const TitleElement = ({ title, noMarginTop }) => (
    <FormListSubHeader title={title} noMarginTop={noMarginTop} />
  );

  const TitleElementWithCcus = ({ title }) => (
    <FormListSubHeader
      title={title}
      ccusComponent={
        disabledAll || !hasValueCCUSbtn ? null : (
          <CcusTitleBlock
            disabled={disabledAll}
            onClick={e => {
              e.preventDefault();
              events.showCcusInfoTranscriptionAgreementDialog();
            }}
          />
        )
      }
    />
  );

  const workerInputTextOnChange = e => {
    events.setValueWorkerSafetyBasicInfo(e.target.name, e.target.value);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name);
  };

  // 都道府県リスト
  const prefectureList = [];
  _.map(PREFECTURE_GROUPS, region =>
    _.map(region.prefectures, prefecture => {
      const p = {
        id: prefecture.id,
        name: prefecture.name,
      };
      prefectureList.push(p);
    })
  );

  // 在留資格の注意メッセージ表示
  const residentStatusWarning = () => {
    const workerResidentStatus =
      formValues.workerSafetyBasicInfo.resident_status;
    switch (workerResidentStatus) {
      case WORKER_RESIDENCE_STATUS_CODES.FOREIGN_LABOR_CONSTRUCTOR:
        return messageUtility.getMessage('E-001-104');
      default:
        return null;
    }
  };

  // 在留資格の項目表示
  const residentStatusDisplay = code => {
    // 「外国人建設就労者」のみ非表示
    if (code === WORKER_RESIDENCE_STATUS_CODES.FOREIGN_LABOR_CONSTRUCTOR) {
      return true;
    }
    return false;
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      {ccusDescription}
      <FormList>
        <TitleElement title='添付書類' noMarginTop={true} />
        <FormListItem label='在籍証明書・雇用契約書など'>
          <FormElement
            info={
              !disabledAll &&
              '登録している添付書類の期限更新をした場合、差し替えが必要となりますので、再度アップロードください。'
            }
          >
            <AttachDocument
              companyDocuments={attachDocuments_Certificate}
              documentCodes={attachDocumentCodes_Certificate}
              itemName=''
              events={events}
              readOnly={disabledAll}
              styleWide={true}
              isFormListDefault={true}
            />
          </FormElement>
        </FormListItem>

        <TitleElementWithCcus title='血液型' />
        <FormListItem label='ABO血液型' safetyDocItem={true}>
          <FormElement ccusComponent={ccusElement('blood_type')}>
            {' '}
            {disabledAll ? (
              <WorkerRadioText
                name='blood_type'
                value={showRadioValueBloodType(
                  formValues.workerSafetyBasicInfo.blood_type
                )}
                disabled={true}
              />
            ) : (
              <FormSelect
                name='blood_type'
                value={
                  formValues.workerSafetyBasicInfo.blood_type !== null
                    ? formValues.workerSafetyBasicInfo.blood_type
                    : ''
                }
                onChange={event => {
                  events.setValueWorkerSafetyBasicInfo(
                    event.target.name,
                    event.target.value
                  );
                }}
              >
                <option value=''>選択してください</option>
                {_.map(BLOOD_TYPE, item => {
                  return (
                    <option key={item.ID} value={item.VALUE}>
                      {item.TEXT}
                    </option>
                  );
                })}
              </FormSelect>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='Rh血液型' safetyDocItem={true}>
          <FormElement ccusComponent={ccusElement('blood_type_rh')}>
            {disabledAll ? (
              <WorkerRadioText
                name='blood_type_rh'
                value={showRadioValueBloodTypeRh(
                  formValues.workerSafetyBasicInfo.blood_type_rh
                )}
                disabled={true}
              />
            ) : (
              <FormSelect
                name='blood_type_rh'
                value={
                  formValues.workerSafetyBasicInfo.blood_type_rh !== null
                    ? formValues.workerSafetyBasicInfo.blood_type_rh
                    : ''
                }
                onChange={event => {
                  events.setValueWorkerSafetyBasicInfo(
                    event.target.name,
                    event.target.value
                  );
                }}
              >
                <option value=''>選択してください</option>
                {_.map(BLOOD_TYPE_RH, item => {
                  return (
                    <option key={item.ID} value={item.VALUE}>
                      {item.TEXT}
                    </option>
                  );
                })}
              </FormSelect>
            )}
          </FormElement>
        </FormListItem>

        <TitleElement title='国籍情報' />
        <FormListItem label='国籍' safetyDocItem={true}>
          <FormElement ccusComponent={ccusElement('foreigner_flag')}>
            {disabledAll ? (
              <WorkerRadioText
                name='foreigner_flag'
                value={showRadioValueForeignerFlag(
                  formValues.workerSafetyBasicInfo.foreigner_flag
                )}
                disabled={true}
              />
            ) : (
              <div className='form-list-radio'>
                {_.map(NATIONALITY_INFO, (item, i) => {
                  return (
                    <FormRadio
                      key={`foreigner_flag${String(i)}`}
                      label={item.TEXT}
                      name='foreigner_flag'
                      value={item.ID}
                      events={events}
                      checked={
                        formValues.workerSafetyBasicInfo.foreigner_flag ===
                        item.ID
                      }
                      disabled={false}
                    />
                  );
                })}
              </div>
            )}
          </FormElement>
        </FormListItem>

        {formValues.workerSafetyBasicInfo.foreigner_flag !==
        NATIONALITY_INFO.FOREIGN.ID ? null : (
          <React.Fragment>
            <FormListItem label='国名' safetyDocItem={true}>
              <FormElement
                ccusComponent={ccusElement('nationality')}
                validate={messages.nationality}
              >
                <WorkerInputText
                  name='nationality'
                  value={formValues.workerSafetyBasicInfo.nationality}
                  messages={messages}
                  disabled={disabledAll}
                  maxLength={20}
                  onChange={workerInputTextOnChange}
                  onBlur={workerInputTextOnBlur}
                />
              </FormElement>
            </FormListItem>

            <FormListItem label='在留資格' safetyDocItem={true}>
              <FormElement
                ccusComponent={ccusElement('resident_status')}
                warning={!messages.resident_status && residentStatusWarning()}
                validate={messages.resident_status}
              >
                {/* 在留資格を自由入力にする場合は ComboBoxにすること
                    このコミットの一つ前に ComboBox の実装例を入れている */}
                <select
                  name='resident_status'
                  className='resident_status'
                  disabled={disabledAll}
                  value={formValues.workerSafetyBasicInfo.resident_status}
                  onChange={e => {
                    events.setWorkerSafetyBasicInfoResidentStatus(
                      e.target.value
                    );
                  }}
                >
                  {disabledAll ? (
                    <option
                      value={formValues.workerSafetyBasicInfo.resident_status}
                    >
                      {formValues.workerSafetyBasicInfo.resident_status_name}
                    </option>
                  ) : (
                    <React.Fragment>
                      {_.map(comboBoxList.residentStatus, status => {
                        // BLDE_V2-45041 Safariブラウザーの場合「外国人建設就労者」を削除する
                        if (
                          isSafariBrowser() &&
                          status.resident_status_code ===
                            WORKER_RESIDENCE_STATUS_CODES.FOREIGN_LABOR_CONSTRUCTOR
                        ) {
                          return null;
                        }
                        return (
                          <option
                            key={status.resident_status_code}
                            value={status.resident_status_code}
                            hidden={residentStatusDisplay(
                              status.resident_status_code
                            )}
                          >
                            {status.resident_status_name}
                          </option>
                        );
                      })}
                    </React.Fragment>
                  )}
                </select>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </FormElement>
            </FormListItem>

            <FormListItem
              label='在留期間満了日'
              safetyDocItem={true}
              isBorder={disabledAll}
            >
              {disabledAll &&
              !formValues.workerSafetyBasicInfo
                .staying_period_expiration_date ? null : (
                <DateInput
                  dateString={
                    formValues.workerSafetyBasicInfo
                      .staying_period_expiration_date
                  }
                  disabled={disabledAll}
                  onChangeValue={val =>
                    events.setValueWorkerSafetyBasicInfo(
                      'staying_period_expiration_date',
                      val
                    )
                  }
                  isPreview={disabledAll}
                  ccusComponent={ccusElement('staying_period_expiration_date')}
                  message={messages.staying_period_expiration_date}
                  warning={wrapperValidExpirationDate(
                    formValues.workerSafetyBasicInfo
                      .staying_period_expiration_date,
                    null,
                    true,
                    messages.staying_period_expiration_date
                  )}
                  jpDelimiterChar={true}
                  onBlur={() =>
                    workerInputTextOnBlur({
                      target: { name: 'staying_period_expiration_date' },
                    })
                  }
                  info={!disabledAll && residentDescriptionMessage}
                />
              )}
            </FormListItem>
            {disabledAll === false && (
              <FormListItem>
                <img
                  className={styles.formListElementImage}
                  src={residenceCardImage}
                  alt=''
                />
              </FormListItem>
            )}
          </React.Fragment>
        )}

        <TitleElement title='経験開始・雇入年月日' />
        <FormListItem label='経験開始年月日' safetyDocItem={true}>
          {disabledAll &&
          !formValues.workerSafetyBasicInfo.experience_start_date ? null : (
            <DateInput
              dateString={
                formValues.workerSafetyBasicInfo.experience_start_date
              }
              disabled={disabledAll}
              onChangeValue={val =>
                events.setValueWorkerSafetyBasicInfo(
                  'experience_start_date',
                  val
                )
              }
              isPreview={disabledAll}
              ccusComponent={ccusElement('experience_start_date')}
              message={messages.experience_start_date}
              jpDelimiterChar={true}
              onBlur={() =>
                workerInputTextOnBlur({
                  target: { name: 'experience_start_date' },
                })
              }
              info={
                !disabledAll &&
                '実務経験の開始年月日を入力してください。作業員名簿上の経験年数が自動計算されます。'
              }
            />
          )}
        </FormListItem>

        <FormListItem label='ブランク期間(月)' safetyDocItem={true}>
          <FormElement
            validate={messages.blank_months}
            info={
              !disabledAll &&
              '休業期間などがある場合は入力してください。入力すると作業員名簿上の経験年数からブランク期間（月）を差し引きます。'
            }
          >
            {!disabledAll ? (
              <WorkerInputText
                name='blank_months'
                className='short'
                value={formValues.workerSafetyBasicInfo.blank_months}
                messages={messages}
                disabled={disabledAll}
                maxLength={4}
                onChange={workerInputTextOnChange}
                onBlur={workerInputTextOnBlur}
                afterTextBox='ヶ月'
              />
            ) : formValues.workerSafetyBasicInfo.blank_months !== undefined &&
              formValues.workerSafetyBasicInfo.blank_months !== null ? (
              <span className={'disabled input-label-text'}>
                {formValues.workerSafetyBasicInfo.blank_months}ヶ月
              </span>
            ) : null}
          </FormElement>
        </FormListItem>

        <FormListItem label='雇入年月日' safetyDocItem={true}>
          {disabledAll &&
          !formValues.workerSafetyBasicInfo.employer_in_date ? null : (
            <DateInput
              dateString={formValues.workerSafetyBasicInfo.employer_in_date}
              disabled={disabledAll}
              onChangeValue={val =>
                events.setValueWorkerSafetyBasicInfo('employer_in_date', val)
              }
              isPreview={disabledAll}
              ccusComponent={ccusElement('employer_in_date')}
              message={messages.employer_in_date}
              jpDelimiterChar={true}
              onBlur={() =>
                workerInputTextOnBlur({ target: { name: 'employer_in_date' } })
              }
            />
          )}
        </FormListItem>

        <TitleElement title='教育' />
        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              「職種・免許・資格」と「受講表彰履歴」タブにも関連した入力項目があります。
            </Description>
          </div>
        )}
        <FormListItem label='雇入時教育受講有無' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement('education')}
            info={
              !disabledAll &&
              '雇入時の安全衛生教育の受講有無を登録してください。'
            }
          >
            {disabledAll ? (
              <WorkerRadioText
                name='education'
                value={showRadioValueExistance(
                  formValues.workerSafetyBasicInfo.education
                )}
                disabled={true}
              />
            ) : (
              <div className='form-list-radio'>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`education${String(i)}`}
                      label={item.TEXT}
                      name='education'
                      value={item.ID}
                      events={events}
                      checked={
                        formValues.workerSafetyBasicInfo.education === item.ID
                      }
                      disabled={false}
                    />
                  );
                })}
              </div>
            )}
          </FormElement>
        </FormListItem>

        {formValues.workerSafetyBasicInfo.education ===
          EXISTANCE_FLAG.EXIST.ID && (
          <FormListItem label='雇入時教育年月日'>
            {disabledAll &&
            !formValues.workerSafetyBasicInfo
              .employment_education_date ? null : (
              <DateInput
                dateString={
                  formValues.workerSafetyBasicInfo.employment_education_date
                }
                disabled={disabledAll || employmentEducationDateIsDisable()}
                onChangeValue={val =>
                  events.setValueWorkerSafetyBasicInfo(
                    'employment_education_date',
                    val
                  )
                }
                isFormListDefault={true}
                isPreview={disabledAll || employmentEducationDateIsDisable()}
                message={messages.employment_education_date}
                jpDelimiterChar={true}
                onBlur={() =>
                  workerInputTextOnBlur({
                    target: { name: 'employment_education_date' },
                  })
                }
              />
            )}
          </FormListItem>
        )}

        <FormListItem label='能力向上教育受講有無' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement('ability_improving_education_code')}
            info={!disabledAll && '能力向上教育の受講有無を登録してください。'}
          >
            {disabledAll ? (
              <WorkerRadioText
                name='ability_improving_education_code'
                value={showRadioValueExistance(
                  formValues.workerSafetyBasicInfo
                    .ability_improving_education_code
                )}
                disabled={true}
              />
            ) : (
              <div className='form-list-radio'>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`ability_improving_education_code${String(i)}`}
                      label={item.TEXT}
                      name='ability_improving_education_code'
                      value={item.ID}
                      events={events}
                      checked={
                        formValues.workerSafetyBasicInfo
                          .ability_improving_education_code === item.ID
                      }
                      disabled={false}
                    />
                  );
                })}
              </div>
            )}
          </FormElement>
        </FormListItem>

        <FormListItem
          label='危険有害業務_再発防止教育受講有無'
          safetyDocItem={true}
        >
          <FormElement
            ccusComponent={ccusElement('recurrent_protection_education_code')}
          >
            {disabledAll ? (
              <WorkerRadioText
                name='recurrent_protection_education_code'
                value={showRadioValueExistance(
                  formValues.workerSafetyBasicInfo
                    .recurrent_protection_education_code
                )}
                disabled={disabledAll}
              />
            ) : (
              <div className='form-list-radio'>
                {_.map(EXISTANCE_FLAG, (item, i) => {
                  return (
                    <FormRadio
                      key={`recurrent_protection_education_code${String(i)}`}
                      label={item.TEXT}
                      name='recurrent_protection_education_code'
                      value={item.ID}
                      events={events}
                      checked={
                        formValues.workerSafetyBasicInfo
                          .recurrent_protection_education_code === item.ID
                      }
                      disabled={false}
                    />
                  );
                })}
              </div>
            )}
          </FormElement>
        </FormListItem>

        <TitleElement title='住所・連絡先' />
        <FormListItem label='郵便番号' safetyDocItem={true}>
          <FormElement
            validate={messages.postal_code}
            ccusComponent={ccusElement('postal_code')}
          >
            {disabledAll &&
            !formValues.workerSafetyBasicInfo.postal_code ? null : (
              <PostalCode
                value={formValues.workerSafetyBasicInfo.postal_code}
                handleOnChange={events.setValueWorkerSafetyBasicInfo}
                setKey='postal_code'
                readOnly={disabledAll}
                error={messages}
                validate={events.validate}
              />
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='都道府県' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement('prefectures')}
            validate={messages.prefectures}
          >
            <ComboBox
              listId={`prefecture-list`}
              disabled={disabledAll}
              value={formValues.workerSafetyBasicInfo.prefectures}
              comboBoxValueKey='name'
              comboBoxList={prefectureList}
              onChange={e => {
                events.setValueWorkerSafetyBasicInfo(
                  'prefectures',
                  e.target.value
                );
              }}
              maxLength={255}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='市区町村' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement('city_name')}
            validate={messages.city_name}
          >
            <WorkerInputText
              name='city_name'
              placeholder={messageUtility.getMessage('I-000-190')}
              value={formValues.workerSafetyBasicInfo.city_name}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='住所１' safetyDocItem={true}>
          <FormElement
            ccusComponent={ccusElement('address1')}
            validate={messages.address1}
          >
            <WorkerInputText
              name='address1'
              placeholder={messageUtility.getMessage('I-000-191')}
              value={formValues.workerSafetyBasicInfo.address1}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='住所２'>
          <FormElement
            ccusComponent={ccusElement('address2')}
            validate={messages.address2}
          >
            <WorkerInputText
              name='address2'
              placeholder='（例）赤坂ビルディング'
              value={formValues.workerSafetyBasicInfo.address2}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='電話番号' safetyDocItem={true}>
          <FormElement
            validate={messages.tel}
            ccusComponent={ccusElement('tel')}
          >
            {disabledAll && !formValues.workerSafetyBasicInfo.tel ? null : (
              <Tel
                value={formValues.workerSafetyBasicInfo.tel}
                handleOnChange={events.setValueWorkerSafetyBasicInfo}
                setKey='tel'
                readOnly={disabledAll}
                error={messages}
                validate={events.validate}
              />
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='FAX'>
          <FormElement
            validate={messages.fax}
            ccusComponent={ccusElement('fax')}
          >
            {disabledAll && !formValues.workerSafetyBasicInfo.fax ? null : (
              <Tel
                value={formValues.workerSafetyBasicInfo.fax}
                handleOnChange={events.setValueWorkerSafetyBasicInfo}
                setKey='fax'
                readOnly={disabledAll}
                error={messages}
                validate={events.validate}
              />
            )}
          </FormElement>
        </FormListItem>

        <FormListItem label='メールアドレス'>
          <FormElement
            ccusComponent={ccusElement('email')}
            validate={messages.email}
          >
            <WorkerInputText
              name='email'
              value={formValues.workerSafetyBasicInfo.email}
              messages={messages}
              disabled={disabledAll}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};
export default WorkerSafetyBasicInfoForm;



// WEBPACK FOOTER //
// ./src/components/worker/form/WorkerSafetyBasicInfoForm.jsx